import { USER_KEY } from "../authProvider";

type StoredUser = {
    account?: {
        billingMode?: string;
        credit?: number;
    };
};

export const shouldSyncLocalAccountCredit = (
    orderAccountId: number,
    userAccountId?: number,
): boolean => Boolean(userAccountId && orderAccountId === userAccountId);

export const deductLocalAccountCredit = (amount: number): number | null => {
    if (amount <= 0) {
        return null;
    }
    const raw = localStorage.getItem(USER_KEY);
    if (!raw) {
        return null;
    }
    try {
        const user = JSON.parse(raw) as StoredUser;
        if (user.account?.billingMode !== "prepaid") {
            return null;
        }
        const previousCredit = user.account.credit ?? 0;
        const newCredit = Math.max(0, previousCredit - amount);
        user.account.credit = newCredit;
        localStorage.setItem(USER_KEY, JSON.stringify(user));
        return newCredit;
    } catch {
        return null;
    }
};
